import { Base } from '@studiometa/js-toolkit';

/**
 * Toast component
 */
export default class Toast extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Toast',
  };

  /**
   *
   * @param {string} content
   */
  addToast(content) {
    const toast = document.createElement('output');
    toast.textContent = content;
    toast.classList.add('toast');
    toast.setAttribute('role', 'status');

    this.$el.append(toast);
  }
}
